<!-- Admissions Banner Section -->
<section class="admissions-banner">
  <div class="fluid-container">
    <div class="admissions-cta">
      <button class="cta-button" routerLink="/register-new-admission">
        Click here for admission registration
      </button>
      <h2>Admissions open for academic year {{ currentYear }} - {{ nextYear }}</h2>
    </div>

    <div class="admissions-carousel">
      <div class="carousel-track">
        @for (slide of slides; track slide.photoURL; let i = $index) {
        <img [src]="slide.photoURL" [alt]="'Admission ' + (i + 1)" />
        }
      </div>
    </div>
  </div>
</section>

<!-- Admissions Details -->
<section class="admissions-info container">
  <hr />
  <div class="info-grid">
    <div class="info-block">
      <h3>Features</h3>
      <ul>
        <li>Science, Maths and English Olympiad<br />Jr. IAS exams, MTS</li>
        <li>NEET, JEE foundations course from 6th std.</li>
        <li>Field trips, picnics and project work</li>
        <li>Karate and Yoga</li>
        <li>Celebration of cultural programmes</li>
        <li>Maximum 35 students per class</li>
        <li>E-Learning</li>
      </ul>
    </div>

    <div class="info-block">
      <h3>The Infrastructure</h3>
      <ul>
        <li>Located 400m from Tathagat Chowk, on 2.5 acres of land</li>
        <li>Big school building with full amenities</li>
        <li>Smart classrooms, Computer, Maths & Science Labs, AV room, Library</li>
        <li>Huge open playground for indoor & outdoor games</li>
      </ul>
    </div>

    <div class="info-block">
      <h3>Extra Activities</h3>
      <ul>
        <li>Abacus [Mental Maths] · Art & Craft · Dance</li>
        <li>Archery · Fencing · Table Tennis · Badminton (with Special Coach)</li>
      </ul>
    </div>

  </div>
</section>